var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M7.5 8.25v4.5m3-4.5v4.5M3 5.25h12m-.75 0l-.65 9.107a1.5 1.5 0 0 1-1.496 1.393H5.897A1.5 1.5 0 0 1 4.4 14.357L3.75 5.25h10.5zm-3 0V3a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75v2.25h4.5z", stroke: "#3C8F9E", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })
  );
});